"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderHistoryService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("../../shared/services/restservice");
const http_1 = require("@angular/common/http");
class OrderHistoryService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.orderHistoryurl = '/rest-services/web-wirelessaccount-services/v1/account/orders';
        this.orderHistoryGenericContentUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=order_history_generic_content';
        this.orderHistoryB2bGenericContentUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=b2b_order_history_generic_content';
        this.agreementUrl = '/rest-services/web-wirelessaccount-services/v1/account/agreements/';
        this.ratingUrl = '/rest-api/account/ratings/v1/ratingsAndReviews';
        this.b2bOrderHistoryurl = '/rest-api/account/order/v1/history/business/';
        this.returnShoppingCartUrl = '/rest-api/return/v1/details';
        this.returnReasonsUrl = '/rest-api/return/v1/reasons';
        this.submitReturnShoppingCartUrl = '/rest-services/web-wirelessaccount-services/v1/account/return/submit';
        this.returnIneligibleMsgGenericContentUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=genericOrderReturnIneligibleMsg';
        this.simSwapGenericContentUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=genericContentReturnSimSwap';
        // CIP:332 - Data passes history
        this.datapassHistoryUrl = '/rest-services/web-wirelessaccount-services/v1/account/datapass/history';
        this.dataPassOrderHistoryDetailsUrl = '/rest-services/web-wirelessaccount-services/v1/account/orders';
    }
    getOrderHistory() {
        return this.get(this.orderHistoryurl).pipe(operators_1.map((data) => data));
    }
    getOrderHistoryDetails(orderId) {
        return this.get(this.orderHistoryurl + '/' + orderId).pipe(operators_1.map((data) => data));
    }
    getOrderHistoryGenericContents() {
        return this.get(this.orderHistoryGenericContentUrl).pipe(operators_1.map((data) => data));
    }
    getOrderHistoryB2bGenericContents() {
        return this.get(this.orderHistoryB2bGenericContentUrl).pipe(operators_1.map((data) => data));
    }
    getAgreementDetails(orderId) {
        return this.get(this.agreementUrl + orderId + '/').pipe(operators_1.map((data) => data));
    }
    ratingandReview(csn, stars, title, text) {
        const inputArgs = new http_1.HttpParams().set('csn', csn).set('stars', stars).set('title', title).set('reviewText', text);
        return this.post(this.ratingUrl, inputArgs.toString()).pipe(operators_1.map((data) => {
            if (data) {
                return data;
            }
        }));
    }
    getB2bOrderHistory(nextIndex) {
        return this.get(this.b2bOrderHistoryurl + nextIndex).pipe(operators_1.map((data) => data));
    }
    getMMAOrderHistory(nextIndex, numberOfOrdersToFetch) {
        return this.get(this.orderHistoryurl + '?startIndex=' + nextIndex + '&numberOfOrdersToFetch=' + numberOfOrdersToFetch).pipe(operators_1.map((data) => data));
    }
    saveReturnShoppingCart(content) {
        return this.post(this.returnShoppingCartUrl, content, true).pipe(operators_1.map((data) => data));
    }
    getReturnShoppingCartDetails() {
        return this.get(this.returnShoppingCartUrl).pipe(operators_1.map((data) => data));
    }
    deleteReturnShoppingCart() {
        return this.delete(this.returnShoppingCartUrl).pipe(operators_1.map((data) => data));
    }
    getReturnReasons() {
        return this.get(this.returnReasonsUrl).pipe(operators_1.map((data) => data));
    }
    submitReturnShoppingCart(content) {
        return this.post(this.submitReturnShoppingCartUrl, content, true).pipe(operators_1.map((data) => data));
    }
    getReturnIneligibleMsgGenericContent() {
        return this.get(this.returnIneligibleMsgGenericContentUrl).pipe(operators_1.map((data) => data));
    }
    getSimSwapGenericContent() {
        return this.get(this.simSwapGenericContentUrl).pipe(operators_1.map((data) => data));
    }
    /**
     * CIP:332 - get data pass history
     */
    gtDataPassPurchaseOrderHistory() {
        return this.get(this.datapassHistoryUrl).pipe(operators_1.map((data) => data));
    }
    /**
     * CIP:332 - data pass order history receipt details
     */
    getDataPassOrderHistoryDetails(orderId) {
        return this.get(this.dataPassOrderHistoryDetailsUrl + '/' + orderId + '?paymentInfo=true').pipe(operators_1.map((data) => data));
    }
}
exports.OrderHistoryService = OrderHistoryService;
//# sourceMappingURL=orderhistory.service.js.map